(function () {

  'use strict';

  angular.module('Settings', ['ngMessages'])

    .constant('SETTINGS_TABS', [
      {
        icon: 'icon-gear',
        section: 'setup',
        caption: 'Setup',
        selected: false,
        show: true
      },
      {
        icon: 'icon-secure-print',
        section: 'securePrint',
        caption: 'SecurePrint',
        selected: false,
        show: true
      },
      {
        icon: 'icon-card-checklist',
        section: 'printRules',
        caption: 'PrintRules',
        selected: false,
        show: true
      },
      {
        icon: 'icon-access-card-2',
        section: 'printixGo',
        caption: 'Printix Go',
        selected: false,
        show: true
      },
      {
        icon: 'icon-capture',
        section: 'workflows',
        caption: 'CaptureWorkflows',
        selected: false,
        show: true
      },
      {
        icon: 'icon-cloud',
        section: 'cloudStorage',
        caption: 'CloudStorage',
        selected: false,
        show: true
      },
      {
        icon: 'icon-analytics',
        section: 'analytics',
        caption: 'Analytics',
        selected: false,
        show: true
      },
      {
        icon: 'icon-mobile-plain',
        section: 'mobilePrint',
        caption: 'MobilePrint',
        selected: false,
        show: true
      },
      {
        icon: 'icon-home-print',
        section: 'homeOffice',
        caption: 'HomeOffice',
        selected: false,
        show: true
      },
      {
        icon: 'icon-connection',
        section: 'snmp',
        caption: 'Snmp',
        selected: false,
        show: true
      },
      {
        icon: 'ta-icon-c_speech_bubble',
        section: 'generativeAi',
        caption: 'GenerativeAi',
        selected: false,
        show: true
      }
    ])

    .controller('SettingsController', function (
      $scope, $rootScope, $location, $filter, TenantListService, toastr, PRINT_QUEUE_ID_SIGN_PLACEMENT,
      SETTINGS_TABS, $routeParams, EventServiceEvents, EventHandlerService, currentTenant,
      SoftwareService, UpdateStrategy, ApplicationType, OperatingSystem, PrintixVersion) {

      $scope.UpdateStrategy = UpdateStrategy;
      $scope.ApplicationType = ApplicationType;
      $scope.OperatingSystem = OperatingSystem;

      $scope.storageProvider = {};
      $scope.tenant = angular.copy(currentTenant);
      $scope.settingsForm = {};
      $scope.mobilePrintForm = {};
      $scope.securePrintConfig = null;
      $scope.securePrintConfigOriginal = null;
      $scope.printLaterJobRetentionDays = [
        { milliseconds: 24 * 60 * 60 * 1000 * 1, days: 1 },
        { milliseconds: 24 * 60 * 60 * 1000 * 3, days: 3 },
        { milliseconds: 24 * 60 * 60 * 1000 * 5, days: 5 },
        { milliseconds: 24 * 60 * 60 * 1000 * 7, days: 7 }
      ];
      $scope.printQueueIdSignPlacement = PRINT_QUEUE_ID_SIGN_PLACEMENT;
      $scope.error = null;
      $scope.me = null;

      $scope.automaticUpdateStrategies = [
        { id: UpdateStrategy.ADVANCE, name: 'AdvanceVersion' },
        { id: UpdateStrategy.GENERAL, name: 'GeneralVersion' },
        { id: UpdateStrategy.SPECIFIC, name: 'SpecificVersion' },
        { id: UpdateStrategy.DISABLED, name: 'DisableAutomaticUpdates' }
      ];
      $scope.automaticUpdateStrategy = { value: $scope.automaticUpdateStrategies[0] };

      $scope.clientMacAvailableVersions = [];
      $scope.clientMacSpecificVersion = {};
      $scope.clientWinAvailableVersions = [];
      $scope.clientWinSpecificVersion = {};
      $scope.redirectorWinAvailableVersions = [];
      $scope.redirectorWinSpecificVersion = {};
      $scope.configuratorWinAvailableVersions = [];
      $scope.configuratorWinSpecificVersion = {};

      $scope.onSelectAutomaticUpdateScheme = function (item, model) {
      };

      $scope.setSection = function (section) {
        $scope.showSection = section;
        const url = $location.path();
        $location.path(url, false).search({ settingsSection: section });
      };

      $scope.clearError = function () {
        $scope.error = null;
      };

      $scope.saveChanges = function (form, event) {
        if (form && event) {
          $scope.waitingForAnswer = true;

          const promises = [
            TenantListService.currentTenant.saveChanges($scope.tenant),
            TenantListService.currentTenant.changeFeaturesInfo($scope.tenant),
            TenantListService.currentTenant.changeFeatureConfigInfo('px:securePrintConfiguration', $scope.securePrintConfigOriginal, $scope.securePrintConfig),
            saveSoftwareUpdateStrategy()
          ];

          Promise.allSettled(promises)
            .then(function (results) {
              if (results.every(result => result.status === 'fulfilled')) {
                // form.$setPristine();
                toastr.success($filter('translate')('ChangesSaved'));
              } else {
                toastr.error($filter('translate')('UpsSomethingWentWrong'));
              }
            })
            .finally(function () {
              $scope.waitingForAnswer = false;
            });
        }
      };

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          $scope.tabs = angular.copy(SETTINGS_TABS);
          loadSecurePrintConfig();
        }
      });

      $scope.$watch(function () {
        return $scope.showSection;
      }, function () {
        switch ($scope.showSection) {
          case 'setup':
            $scope.helpCaption = 'HelpSettingsPage';
            break;
          case 'securePrint':
            $scope.helpCaption = 'HelpSettingsSecurePrint';
            break;
          case 'printRules':
            $scope.helpCaption = 'HelpSettingsPrintRules';
            break;
          case 'printixGo':
            $scope.helpCaption = 'HelpSettingsGoConfiguration';
            break;
          case 'workflows':
            $scope.helpCaption = 'HelpCaptureWorkflows';
            break;
          case 'cloudStorage':
            $scope.helpCaption = 'HelpSettingsCloudStorage';
            break;
          case 'analytics':
            $scope.helpCaption = 'HelpSettingsAnalytics';
            break;
          case 'mobilePrint':
            $scope.helpCaption = 'HelpSettingsMobilePrint';
            break;
          case 'homeOffice':
            $scope.helpCaption = 'HelpSettingsHomeOffice';
            break;
          case 'snmp':
            $scope.helpCaption = 'HelpSettingsSnmp';
            break;
          case 'generativeAi':
            $scope.helpCaption = 'HelpSettingsGenerativeAi';
            break;
        }
      });

      $scope.$on('REQUEST_ERROR_HELP', (event, data) => {
        $scope.error = data.error;
      });

      (function () {
        EventHandlerService.deRegisterListeners();
        $scope.enableOnDevice = $scope.tenant.info.enableOnDevice;
        $scope.goDisableContentFormated = $filter('translate')('PrintixGoEnableOnDeviceText');
        $scope.showSection = $routeParams.settingsSection || 'setup';
        loadSoftwareVersions();
      })();

      function loadSecurePrintConfig() {
        if (TenantListService.currentTenant?.info._embedded.productsAndFeatures.products.FREEDOM?.enabled) {
          TenantListService.currentTenant.getFeatureConfigInfo('px:securePrintConfiguration')
            .then(function (response) {
              const securePrintConfig = response.data;
              $scope.securePrintConfig = angular.copy(securePrintConfig);
              $scope.securePrintConfigOriginal = securePrintConfig;
            })
            .catch(function () {
            });
        }
      }

      function loadSoftwareVersions() {
        SoftwareService.getVersionsOfDesktopApplications()
          .then(function (softwareVersions) {
            $scope.softwareVersions = softwareVersions;
            initializeDropdowns();
          })
          .catch(function () {
          });
      }

      function saveSoftwareUpdateStrategy() {
        const softwareUpdateStrategy = {
          updateStrategy: $scope.automaticUpdateStrategy.value.id
        };
        if (softwareUpdateStrategy.updateStrategy === UpdateStrategy.SPECIFIC) {
          softwareUpdateStrategy.specificVersions = [
            {
              appType: ApplicationType.CLIENT,
              os: OperatingSystem.MAC,
              version: $scope.clientMacSpecificVersion.value.version,
              files: $scope.clientMacSpecificVersion.value.files
            },
            {
              appType: ApplicationType.CLIENT,
              os: OperatingSystem.WIN,
              version: $scope.clientWinSpecificVersion.value.version,
              files: $scope.clientWinSpecificVersion.value.files
            },
            {
              appType: ApplicationType.REDIRECTOR,
              os: OperatingSystem.WIN,
              version: $scope.redirectorWinSpecificVersion.value.version,
              files: $scope.redirectorWinSpecificVersion.value.files
            },
            {
              appType: ApplicationType.CONFIGURATOR,
              os: OperatingSystem.WIN,
              version: $scope.configuratorWinSpecificVersion.value.version,
              files: $scope.configuratorWinSpecificVersion.value.files
            }
          ];
        }
        return SoftwareService.setUpdateStrategyOfDesktopApplications(softwareUpdateStrategy);
      }

      function getApplication(applicationType, operatingSystem) {
        return $scope.softwareVersions?.applications.find(application => application.appType === applicationType && application.os === operatingSystem);
      }

      $scope.getApplicationAdvanceVersion = function (applicationType, operatingSystem) {
        return getApplication(applicationType, operatingSystem)?.advanceVersion;
      };

      $scope.getApplicationGeneralVersion = function (applicationType, operatingSystem) {
        return getApplication(applicationType, operatingSystem)?.generalVersion;
      };

      function initializeDropdowns() {
        $scope.automaticUpdateStrategy.value = $scope.automaticUpdateStrategies.find(strategy => strategy.id === $scope.softwareVersions.updateStrategy);

        const clientMac = getApplication(ApplicationType.CLIENT, OperatingSystem.MAC);
        $scope.clientMacAvailableVersions = getSpecificVersionDropdownItems(clientMac);
        $scope.clientMacSpecificVersion.value = getSpecificVersionSelectedDropdownItem($scope.clientMacAvailableVersions, clientMac);

        const clientWin = getApplication(ApplicationType.CLIENT, OperatingSystem.WIN);
        $scope.clientWinAvailableVersions = getSpecificVersionDropdownItems(clientWin);
        $scope.clientWinSpecificVersion.value = getSpecificVersionSelectedDropdownItem($scope.clientWinAvailableVersions, clientWin);

        const redirectorWin = getApplication(ApplicationType.REDIRECTOR, OperatingSystem.WIN);
        $scope.redirectorWinAvailableVersions = getSpecificVersionDropdownItems(redirectorWin);
        $scope.redirectorWinSpecificVersion.value = getSpecificVersionSelectedDropdownItem($scope.redirectorWinAvailableVersions, redirectorWin);

        const configuratorWin = getApplication(ApplicationType.CONFIGURATOR, OperatingSystem.WIN);
        $scope.configuratorWinAvailableVersions = getSpecificVersionDropdownItems(configuratorWin);
        $scope.configuratorWinSpecificVersion.value = getSpecificVersionSelectedDropdownItem($scope.configuratorWinAvailableVersions, configuratorWin);
      }

      function getSpecificVersionDropdownItems(application) {
        const availableVersions = angular.copy(application?.availableVersions || []);
        let specificVersion = application?.specificVersion;
        if (specificVersion) {
          const foundSpecificVersion = availableVersions.find(av => av.version === specificVersion.version);
          if (!foundSpecificVersion) {
            specificVersion = angular.copy(specificVersion);
            specificVersion.obsolete = true;
            availableVersions.push(specificVersion);
          }
        }
        availableVersions.sort((first, second) =>
          new PrintixVersion(second.version).compareTo(new PrintixVersion(first.version))
        );
        return availableVersions;
      }

      function getSpecificVersionSelectedDropdownItem(availableVersions, application) {
        const version = application?.specificVersion?.version || application?.generalVersion;
        return availableVersions.find(av => av.version === version) || availableVersions[0];
      }

      // LISTENERS

      const deregisterSecurePrintConfigurationUpdatedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SECURE_PRINT_CONFIGURATION_UPDATED, function (event, data) {
        TenantListService.currentTenant.refreshInfo()
          .then(function (response) {
            loadSecurePrintConfig();
          })
          .catch(function () {
          });
      });

      const deregisterSecurePrintConfigurationAddedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SECURE_PRINT_CONFIGURATION_ADDED, function (event, data) {
        TenantListService.currentTenant.refreshInfo()
          .then(function (response) {
            loadSecurePrintConfig();
          })
          .catch(function () {
          });
      });

      const deregisterSecurePrintConfigurationRemovedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.SECURE_PRINT_CONFIGURATION_REMOVED, function (event, data) {
        TenantListService.currentTenant.refreshInfo()
          .then(function (response) {
            loadSecurePrintConfig();
          })
          .catch(function () {
          });
      });

      const deregisterTenantUpdatedListener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.TENANT_UPDATED, function (event, data) {
        TenantListService.currentTenant.refreshInfo()
          .then(function (response) {
            loadSecurePrintConfig();
          })
          .catch(function () {
          });
      });

      $scope.$on('$destroy', function () {
        deregisterSecurePrintConfigurationUpdatedListener();
        deregisterSecurePrintConfigurationAddedListener();
        deregisterSecurePrintConfigurationRemovedListener();
        deregisterTenantUpdatedListener();
      });

    });

})();
